import { useCallback, useEffect, useState } from "react";
import { OPEN_NOW_CATEGORY, OPEN_NOW_FILTER_OBJ } from "../../utils";
const convertSelectedToActiveFilters = ({ selectedFilters, allFilters, getFromInitialSelectedFilters, }) => {
    const activeFilters = {};
    for (const selectedFilter in selectedFilters) {
        const [categoryKey, filterKey] = selectedFilter.split(".");
        if (categoryKey === OPEN_NOW_CATEGORY) {
            activeFilters[categoryKey] = [OPEN_NOW_FILTER_OBJ];
            continue;
        }
        if (selectedFilters[selectedFilter]?.selected) {
            if (getFromInitialSelectedFilters) {
                const filterObj = {
                    name: "",
                    key: filterKey,
                    value: filterKey,
                };
                if (activeFilters[categoryKey]) {
                    activeFilters[categoryKey].push(filterObj);
                }
                else {
                    activeFilters[categoryKey] = [filterObj];
                }
                continue;
            }
            const categoryFilters = allFilters.find((filterCategory) => filterCategory.key === categoryKey);
            const filter = categoryFilters?.filters.find((filter) => filter?.key === filterKey);
            if (activeFilters[categoryKey]) {
                activeFilters[categoryKey].push(filter);
            }
            else {
                activeFilters[categoryKey] = [filter];
            }
        }
    }
    return activeFilters;
};
const toggleFilterInCategory = (categoryFilters, targetFilter) => {
    const isFilterSelected = categoryFilters.some((existingFilter) => existingFilter?.key === targetFilter.key);
    return isFilterSelected
        ? categoryFilters.filter((existingFilter) => existingFilter?.key !== targetFilter.key)
        : [...categoryFilters, targetFilter];
};
export const useStoreFilters = ({ selectedFilters, allFilters, handleChangeFilters, isOpenNowFilterEnabled, }) => {
    const [activeFilters, setActiveFilters] = useState(convertSelectedToActiveFilters({ selectedFilters, allFilters, getFromInitialSelectedFilters: true }));
    const applyFilters = ({ categoryToSkip, additionalCategory = {} } = {}) => {
        const filtersCategories = { ...activeFilters, ...additionalCategory };
        const currentFilters = {};
        const categoriesToProcess = Object.keys(filtersCategories).filter((category) => category !== categoryToSkip);
        for (const category of categoriesToProcess) {
            const validFilters = filtersCategories[category]?.filter((filter) => Boolean(filter)) || [];
            for (const filter of validFilters) {
                const filterKey = `${category}.${filter.key}`;
                currentFilters[filterKey] = {
                    key: filter.key,
                    selected: true,
                    category,
                };
            }
        }
        handleChangeFilters(currentFilters);
    };
    const changeFilters = useCallback((category, filter) => {
        setActiveFilters((prevFilters) => {
            const currentCategoryFilters = prevFilters[category] ?? [];
            const updatedCategoryFilters = toggleFilterInCategory(currentCategoryFilters, filter);
            return {
                ...prevFilters,
                [category]: updatedCategoryFilters,
            };
        });
    }, []);
    const checkFiltersStatus = useCallback((category, filterKey) => {
        return activeFilters[category]?.some((f) => f?.key === filterKey) || false;
    }, [activeFilters]);
    useEffect(() => {
        if (selectedFilters) {
            setActiveFilters(convertSelectedToActiveFilters({ selectedFilters, allFilters }));
        }
    }, [allFilters, selectedFilters]);
    const handleApplyOpenNowCheckbox = () => {
        if (!isOpenNowFilterEnabled)
            return;
        const applyFiltersParams = {};
        if (activeFilters[OPEN_NOW_CATEGORY]) {
            applyFiltersParams.categoryToSkip = OPEN_NOW_CATEGORY;
        }
        else {
            applyFiltersParams.additionalCategory = {
                [OPEN_NOW_CATEGORY]: [OPEN_NOW_FILTER_OBJ],
            };
        }
        applyFilters(applyFiltersParams);
    };
    const handleDropdownSelect = (categoryKey, x, e) => {
        if (e.option)
            changeFilters(categoryKey, e.option);
    };
    const handleDropdownRestart = (categoryKey) => {
        applyFilters({ categoryToSkip: categoryKey });
    };
    return {
        handleDropdownRestart,
        handleDropdownSelect,
        handleApplyOpenNowCheckbox,
        checkFiltersStatus,
        changeFilters,
        applyFilters,
        activeFilters,
    };
};
//# sourceMappingURL=useStoreFilters.js.map